function request(actionType) {
    return {
        type: actionType
    }
}
function success(actionType, response) {
    return {
        type: actionType,
        payload: response
    }
}
function failure(actionType, error) {
    return {
        type: actionType,
        payload: error
    }
}
const USER_REQUEST = {
    VERIFY_EMAIL_RESET: "VERIFY_EMAIL_RESET",
    VERIFY_EMAIL_REQUEST: "VERIFY_EMAIL_REQUEST",
    VERIFY_EMAIL_FAILURE: "VERIFY_EMAIL_FAILURE",
    VERIFY_EMAIL_SUCCESS: "VERIFY_EMAIL_SUCCESS",
    USER_SIGNIN_RESET: "USER_SIGNIN_RESET",
    USER_SIGNIN_REQUEST: "USER_SIGNIN_REQUEST",
    USER_SIGNIN_SUCCESS: "USER_SIGNIN_SUCCESS",
    USER_SIGNIN_FAILURE: "USER_SIGNIN_FAILURE",
    UPDATE_TENANT_PROFILE_REQUEST: "UPDATE_TENANT_PROFILE_REQUEST",
    UPDATE_TENANT_PROFILE_SUCCESS: "UPDATE_TENANT_PROFILE_SUCCESS",
    UPDATE_TENANT_PROFILE_FAILURE: "UPDATE_TENANT_PROFILE_FAILURE",
    UPDATE_LANDLORD_PROFILE_REQUEST: "UPDATE_LANDLORD_PROFILE_REQUEST",
    UPDATE_LANDLORD_PROFILE_SUCCESS: "UPDATE_LANDLORD_PROFILE_SUCCESS",
    UPDATE_LANDLORD_PROFILE_FAILURE: "UPDATE_LANDLORD_PROFILE_FAILURE",

    GET_STAT_REQUEST: "GET_STAT_REQUEST",
    GET_STAT_SUCCESS: "GET_STAT_SUCCESS",
    GET_STAT_FAILURE: "GET_STAT_FAILURE",

    GET_USER_PROFILE_REQUEST: "GET_USER_PROFILE_REQUEST",
    GET_USER_PROFILE_SUCCESS: "GET_USER_PROFILE_SUCCESS",
    GET_USER_PROFILE_FAILURE: "GET_USER_PROFILE_FAILURE",

    RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
    RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
    RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",

    GET_USER_EMAIL_REQUEST: "GET_USER_EMAIL_REQUEST",
    GET_USER_EMAIL_SUCCESS: "GET_USER_EMAIL_SUCCESS",
    GET_USER_EMAIL_FAILURE: "GET_USER_EMAIL_FAILURE",
    GET_USER_EMAIL_RESET: "GET_USER_EMAIL_RESET",

    GET_USER_CODE_REQUEST: "GET_USER_CODE_REQUEST",
    GET_USER_CODE_SUCCESS: "GET_USER_CODE_SUCCESS",
    GET_USER_CODE_FAILURE: "GET_USER_CODE_FAILURE",
    GET_USER_CODE_RESET: "GET_USER_CODE_RESET",

}
const LOACTION_REQUEST = {
    GET_STATES_REQUEST: "GET_STATES_REQUEST",
    GET_STATES_SUCCESS: "GET_STATES_SUCCESS",
    GET_STATES_FAILURE: "GET_STATES_FAILURE",
    GET_CITIES_REQUEST: "GET_CITIES_REQUEST",
    GET_CITIES_SUCCESS: "GET_CITIES_SUCCESS",
    GET_CITIES_FAILURE: "GET_CITIES_FAILURE",
    ADD_LOCATION_REQUEST: "ADD_LOCATION_REQUEST",
    ADD_LOCATION_SUCCESS: "ADD_LOCATION_SUCCESS",
    ADD_LOCATION_FAILURE: "ADD_LOCATION_FAILURE",
    GET_LOCATION_REQUEST: "GET_LOCATION_REQUEST",
    GET_LOCATION_SUCCESS: "GET_LOCATION_SUCCESS",
    GET_LOCATION_FAILURE: "GET_LOCATION_FAILURE",
}
const BUSSINESS_PROFILE = {
    GET_BUSSINESS_PROFILE_REQUEST: "GET_BUSSINESS_PROFILE_REQUEST",
    GET_BUSSINESS_PROFILE_SUCCESS: "GET_BUSSINESS_PROFILE_SUCCESS",
    GET_BUSSINESS_PROFILE_FAILURE: "GET_BUSSINESS_PROFILE_FAILURE",
    ADD_BUSSINESS_PROFILE_REQUEST: "ADD_BUSSINESS_PROFILE_REQUEST",
    ADD_BUSSINESS_PROFILE_SUCCESS: "ADD_BUSSINESS_PROFILE_SUCCESS",
    ADD_BUSSINESS_PROFILE_FAILURE: "ADD_BUSSINESS_PROFILE_FAILURE",
}
const LOOKUP_REQUEST = {
    GET_ALL_LOOKUP_REQUEST: "GET_ALL_LOOKUP_REQUEST",
    GET_ALL_LOOKUP_SUCCESS: "GET_ALL_LOOKUP_SUCCESS",
    GET_ALL_LOOKUP_FAILURE: "GET_ALL_LOOKUP_FAILURE",
    GET_ALL_LOOKUP_KEYS_REQUEST: "GET_ALL_LOOKUP_KEYS_REQUEST",
    GET_ALL_LOOKUP_KEYS_SUCCESS: "GET_ALL_LOOKUP_KEYS_SUCCESS",
    GET_ALL_LOOKUP_KEYS_FAILURE: "GET_ALL_LOOKUP_KEYS_FAILURE",
    GET_LOOKUP_BY_TYPE_REQUEST: "GET_LOOKUP_BY_TYPE_REQUEST",
    GET_LOOKUP_BY_TYPE_SUCCESS: "GET_LOOKUP_BY_TYPE_SUCCESS",
    GET_LOOKUP_BY_TYPE_FAILURE: "GET_LOOKUP_BY_TYPE_FAILURE",
}
const REQUIREMENT_PROPERTY_REQUEST = {
    GET_REQUIREMENT_REQUEST: "GET_REQUIREMENT_REQUEST",
    GET_REQUIREMENT_SUCCESS: "GET_REQUIREMENT_SUCCESS",
    GET_REQUIREMENT_FAILURE: "GET_REQUIREMENT_FAILURE",
    ADD_REQUIREMENT_REQUEST: "ADD_REQUIREMENT_REQUEST",
    ADD_REQUIREMENT_SUCCESS: "ADD_REQUIREMENT_SUCCESS",
    ADD_REQUIREMENT_FAILURE: "ADD_REQUIREMENT_FAILURE",
    EDIT_REQUIREMENT_REQUEST: "EDIT_REQUIREMENT_REQUEST",
    EDIT_REQUIREMENT_SUCCESS: "EDIT_REQUIREMENT_SUCCESS",
    EDIT_REQUIREMENT_FAILURE: "EDIT_REQUIREMENT_FAILURE",
    ADD_REQUIREMENTDETAIL_SUCCESS: "ADD_REQUIREMENTDETAIL_SUCCESS",
    REMOVE_REQUIREMENT_SUCCESS: "REMOVE_REQUIREMENT_SUCCESS",
}
const REVIEW_PROPERTY = {
    GET_TENANT_REVIEW_LOADING: "GET_TENANT_REVIEW_LOADING",
    GET_TENANT_REVIEW_SUCCESS: "GET_TENANT_REVIEW_SUCCESS",
    GET_TENANT_REVIEW_FAILURE: "GET_TENANT_REVIEW_FAILURE",
    GET_LANDLORD_REVIEW_LOADING: "GET_LANDLORD_REVIEW_LOADING",
    GET_LANDLORD_REVIEW_SUCCESS: "GET_LANDLORD_REVIEW_SUCCESS",
    GET_LANDLORD_REVIEW_FAILURE: "GET_LANDLORD_REVIEW_FAILURE"
}
const POST_PROPERTY = {
    ADD_PROPERTY_FILE_REQUEST: "ADD_PROPERTY_FILE_REQUEST",
    ADD_PROPERTY_FILE_FAILURE: "ADD_PROPERTY_FILE_FAILURE",
    ADD_PROPERTY_FILE_SUCCESS: "ADD_PROPERTY_FILE_SUCCESS",

    REMOVE_PROPERTY_FILE_REQUEST: "REMOVE_PROPERTY_FILE_REQUEST",
    REMOVE_PROPERTY_FILE_FAILURE: "REMOVE_PROPERTY_FILE_FAILURE",
    REMOVE_PROPERTY_FILE_SUCCESS: "REMOVE_PROPERTY_FILE_SUCCESS",

    GET_PROPERTY_FILE_BY_ID_REQUEST: "GET_PROPERTY_FILE_BY_ID_REQUEST",
    GET_PROPERTY_FILE_BY_ID_SUCCESS: "GET_PROPERTY_FILE_BY_ID_SUCCESS",
    GET_PROPERTY_FILE_BY_ID_FAILURE: "GET_PROPERTY_FILE_BY_ID_FAILURE",

    GET_ALL_PROPERTY_FILES_REQUEST: "GET_ALL_PROPERTY_FILES_REQUEST",
    GET_ALL_PROPERTY_FILES_SUCCESS: "GET_ALL_PROPERTY_FILES_SUCCESS",
    GET_ALL_PROPERTY_FILES_FAILURE: "GET_ALL_PROPERTY_FILES_FAILURE",

    GET_PROPERTY_DETAIL_REQUEST: "GET_PROPERTY_DETAIL_REQUEST",
    GET_PROPERTY_DETAIL_SUCCESS: "GET_PROPERTY_DETAIL_SUCCESS",
    GET_PROPERTY_DETAIL_FAILURE: "GET_PROPERTY_DETAIL_FAILURE",


    ADD_PROPERTYDETAIL_SUCCESS: "ADD_PROPERTYDETAIL_SUCCESS",
    REMOVE_PROPERTYDETAIL_SUCCESS: "REMOVE_PROPERTYDETAIL_SUCCESS",

}
const BROWSE_LISTING = {
    GET_LIST_REQUEST: "GET_LIST_REQUEST",
    GET_LIST_FAILURE: "GET_LIST_FAILURE",
    GET_LIST_SUCCESS: "GET_LIST_SUCCESS",

    GET_TENANTS_REQUEST: "GET_TENANTS_REQUEST",
    GET_TENANTS_FAILURE: "GET_TENANTS_FAILURE",
    GET_TENANTS_SUCCESS: "GET_TENANTS_SUCCESS",

    TENANT_CONNECTION_REQUEST: "TENANT_CONNECTION_REQUEST",
    TENANT_CONNECTION_SUCCESS: "TENANT_CONNECTION_SUCCESS",
    TENANT_CONNECTION_FAILURE: "TENANT_CONNECTION_FAILURE",
    TENANT_CONNECTION_RESET: "TENANT_CONNECTION_RESET",
}

const CONNECTION_REQUEST = {
    GET_ALL_CONNECTION_REQUEST: "GET_ALL_CONNECTION_REQUEST",
    GET_ALL_CONNECTION_SUCCESS: "GET_ALL_CONNECTION_SUCCESS",
    GET_ALL_CONNECTION_FAILURE: "GET_ALL_CONNECTION_FAILURE",

    ADD_REMOVE_TO_FAVOURITE_CONNECTION_REQUEST: "ADD_REMOVE_TO_FAVOURITE_CONNECTION_REQUEST",
    ADD_REMOVE_TO_FAVOURITE_CONNECTION_SUCCESS: "ADD_REMOVE_TO_FAVOURITE_CONNECTION_SUCCESS",
    ADD_REMOVE_TO_FAVOURITE_CONNECTION_FAILURE: "ADD_REMOVE_TO_FAVOURITE_CONNECTION_FAILURE",

    REMOVE_CONNECTION_REQUEST: "REMOVE_CONNECTION_REQUEST",
    REMOVE_CONNECTION_SUCCESS: "REMOVE_CONNECTION_SUCCESS",
    REMOVE_CONNECTION_FAILURE: "REMOVE_CONNECTION_FAILURE",

    SEND_CONNECTION_REQUEST: "SEND_CONNECTION_REQUEST",
    SEND_CONNECTION_SUCCESS: "SEND_CONNECTION_SUCCESS",
    SEND_CONNECTION_FAILURE: "SEND_CONNECTION_FAILURE",

    ACCEPT_CONNECTION_REQUEST: "ACCEPT_CONNECTION_REQUEST",
    ACCEPT_CONNECTION_SUCCESS: "ACCEPT_CONNECTION_SUCCESS",
    ACCEPT_CONNECTION_FAILURE: "ACCEPT_CONNECTION_FAILURE",
    REQUEST_RESET: "REQUEST_RESET",
    REJECT_CONNECTION_REQUEST: "REJECT_CONNECTION_REQUEST",
    REJECT_CONNECTION_SUCCESS: "REJECT_CONNECTION_SUCCESS",
    REJECT_CONNECTION_FAILURE: "REJECT_CONNECTION_FAILURE",
}
const CHAT_REQUEST = {
    JOIN_CHAT_REQUEST: "JOIN_CHAT_REQUEST",
    JOIN_CHAT_SUCCESS: "JOIN_CHAT_SUCCESS",
    JOIN_CHAT_FAILURE: "JOIN_CHAT_FAILURE",

    ALL_CHAT_REQUEST: "ALL_CHAT_REQUEST",
    ALL_CHAT_SUCCESS: "ALL_CHAT_SUCCESS",
    ALL_CHAT_FAILURE: "ALL_CHAT_FAILURE",

    USER_CHAT_REQUEST: "USER_CHAT_REQUEST",
    USER_CHAT_SUCCESS: "USER_CHAT_SUCCESS",
    USER_CHAT_FAILURE: "USER_CHAT_FAILURE",

    SEND_CHAT_REQUEST: "SEND_CHAT_REQUEST",
    SEND_CHAT_SUCCESS: "SEND_CHAT_SUCCESS",
    SEND_CHAT_FAILURE: "SEND_CHAT_FAILURE",

    FAV_UNFAV_REQUEST: "FAV_UNFAV_REQUEST",
    FAV_UNFAV_SUCCESS: "FAV_UNFAV_SUCCESS",
    FAV_UNFAV_FAILURE: "FAV_UNFAV_FAILURE",

    SEND_OR_RECIEVE_MESSAGE: "SEND_OR_RECIEVE_MESSAGE",

    SELECT_CHAT_LOCATION: "SELECT_CHAT_LOCATION"
}
const REPORTS_REQUEST = {
    GET_PROPERTY_REPORT_REQUEST: "GET_PROPERTY_REPORT_REQUEST",
    GET_PROPERTY_REPORT_SUCCESS: "GET_PROPERTY_REPORT_SUCCESS",
    GET_PROPERTY_REPORT_FAILURE: "GET_PROPERTY_REPORT_FAILURE",

    GET_SUBSCRIPTION_REPORT_REQUEST: "GET_SUBSCRIPTION_REPORT_REQUEST",
    GET_SUBSCRIPTION_REPORT_SUCCESS: "GET_SUBSCRIPTION_REPORT_SUCCESS",
    GET_SUBSCRIPTION_REPORT_FAILURE: "GET_SUBSCRIPTION_REPORT_FAILURE",

    GET_USER_REPORT_REQUEST: "GET_USER_REPORT_REQUEST",
    GET_USER_REPORT_SUCCESS: "GET_USER_REPORT_SUCCESS",
    GET_USER_REPORT_FAILURE: "GET_USER_REPORT_FAILURE",

    GET_MEDIA_LIST_REQUEST: "GET_MEDIA_LIST_REQUEST",
    GET_MEDIA_LIST_SUCCESS: "GET_MEDIA_LIST_SUCCESS",
    GET_MEDIA_LIST_FAILURE: "GET_MEDIA_LIST_FAILURE",

    GET_SUBSCRIPTION_BY_MONTH_REQUEST: "GET_SUBSCRIPTION_BY_MONTH_REQUEST",
    GET_SUBSCRIPTION_BY_MONTH_SUCCESS: "GET_SUBSCRIPTION_BY_MONTH_SUCCESS",
    GET_SUBSCRIPTION_BY_MONTH_FAILURE: "GET_SUBSCRIPTION_BY_MONTH_FAILURE",

    GET_SUBSCRIPTION_BY_STATE_REQUEST: "GET_SUBSCRIPTION_BY_STATE_REQUEST",
    GET_SUBSCRIPTION_BY_STATE_SUCCESS: "GET_SUBSCRIPTION_BY_STATE_SUCCESS",
    GET_SUBSCRIPTION_BY_STATE_FAILURE: "GET_SUBSCRIPTION_BY_STATE_FAILURE",

    GET_SUBSCRIPTION_BY_COUNT_REQUEST: "GET_SUBSCRIPTION_BY_COUNT_REQUEST",
    GET_SUBSCRIPTION_BY_COUNT_SUCCESS: "GET_SUBSCRIPTION_BY_COUNT_SUCCESS",
    GET_SUBSCRIPTION_BY_COUNT_FAILURE: "GET_SUBSCRIPTION_BY_COUNT_FAILURE",

    GET_USER_BY_COUNT_REQUEST: "GET_USER_BY_COUNT_REQUEST",
    GET_USER_BY_COUNT_SUCCESS: "GET_USER_BY_COUNT_SUCCESS",
    GET_USER_BY_COUNT_FAILURE: "GET_USER_BY_COUNT_FAILURE",

    GET_USER_BY_MONTH_REQUEST: "GET_USER_BY_MONTH_REQUEST",
    GET_USER_BY_MONTH_SUCCESS: "GET_USER_BY_MONTH_SUCCESS",
    GET_USER_BY_MONTH_FAILURE: "GET_USER_BY_MONTH_FAILURE",

    GET_ALL_USER_REQUEST: "GET_ALL_USER_REQUEST",
    GET_ALL_USER_SUCCESS: "GET_ALL_USER_SUCCESS",
    GET_ALL_USER_FAILURE: "GET_ALL_USER_FAILURE",
}
const INDUSTRY_REQUEST = {
    GET_INDUSTRY_REQUEST: "GET_INDUSTRY_REQUEST",
    GET_INDUSTRY_SUCCESS: "GET_INDUSTRY_SUCCESS",
    GET_INDUSTRY_FAILURE: "GET_INDUSTRY_FAILURE",

    ADD_INDUSTRY_REQUEST: "ADD_INDUSTRY_REQUEST",
    ADD_INDUSTRY_SUCCESS: "ADD_INDUSTRY_SUCCESS",
    ADD_INDUSTRY_FAILURE: "ADD_INDUSTRY_FAILURE"
}
const PROPERTIES_REQUEST = {
    GET_ALL_PROPERTIES_REQUEST: "GET_ALL_PROPERTIES_REQUEST",
    GET_ALL_PROPERTIES_SUCCESS: "GET_ALL_PROPERTIES_SUCCESS",
    GET_ALL_PROPERTIES_FAILURE: "GET_ALL_PROPERTIES_FAILURE",

    RECORD_DEAL_REQUEST: "RECORD_DEAL_REQUEST",
    RECORD_DEAL_SUCCESS: "RECORD_DEAL_SUCCESS",
    RECORD_DEAL_FAILURE: "RECORD_DEAL_FAILURE",
    RECORD_DEAL_RESET: "RECORD_DEAL_RESET",
    GET_PROPERTY_BY_ID_REQUEST: "GET_PROPERTY_BY_ID_REQUEST",
    GET_PROPERTY_BY_ID_SUCCESS: "GET_PROPERTY_BY_ID_SUCCESS",
    GET_PROPERTY_BY_ID_FAILURE: "GET_PROPERTY_BY_ID_FAILURE",

    CHANGE_MEDIA_REQUEST: "CHANGE_MEDIA_REQUEST",
    CHANGE_MEDIA_SUCCESS: "CHANGE_MEDIA_SUCCESS",
    CHANGE_MEDIA_FAILURE: "CHANGE_MEDIA_FAILURE",

    GET_ANALYTICS_REQUEST: "GET_ANALYTICS_REQUEST",
    GET_ANALYTICS_SUCCESS: "GET_ANALYTICS_SUCCESS",
    GET_ANALYTICS_FAILURE: "GET_ANALYTICS_FAILURE"
}
const LANDING_PAGE_REQUEST = {
    ALL_REQUIREMENT_REQUEST: "ALL_REQUIREMENT_REQUEST",
    ALL_REQUIREMENT_SUCCESS: "ALL_REQUIREMENT_SUCCESS",
    ALL_REQUIREMENT_FAILURE: "ALL_REQUIREMENT_FAILURE",

    ALL_PROPERTY_REQUEST: "ALL_PROPERTY_REQUEST",
    ALL_PROPERTY_SUCCESS: "ALL_PROPERTY_SUCCESS",
    ALL_PROPERTY_FAILURE: "ALL_PROPERTY_FAILURE",


}



export {
    request,
    success,
    failure,
    USER_REQUEST,
    LOACTION_REQUEST,
    BUSSINESS_PROFILE,
    LOOKUP_REQUEST,
    REQUIREMENT_PROPERTY_REQUEST,
    REVIEW_PROPERTY,
    POST_PROPERTY,
    BROWSE_LISTING,
    CONNECTION_REQUEST,
    REPORTS_REQUEST,
    PROPERTIES_REQUEST,
    INDUSTRY_REQUEST,
    LANDING_PAGE_REQUEST,
    CHAT_REQUEST
}
